import * as React from "react";
import { TableBody } from "./TableBody";
import { TableHeader } from "./TableHeader";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
/**
 *
 * @param props
 */
var TableComp = function (props) {
    var clazzName = joinClasses(props.className || "", "scl-m-table__wrapper");
    if (!props.data) {
        return null;
    }
    // Data
    var dataColumns = props.data.columns;
    var dataRows = props.data.rows;
    return (React.createElement("div", { className: clazzName },
        React.createElement("table", { className: "scl-m-table" },
            !props.withoutColumnHeader && (React.createElement(TableHeader, { columns: dataColumns, activeSort: props.data.sort, onSortChange: props.onSortChange, hasActions: props.hasActions })),
            React.createElement(TableBody, { rows: dataRows, columns: dataColumns, hasActions: props.hasActions }))));
};
/**
 *
 */
export var Table = asThemeConsumer(TableComp);
